<template>
    <div class="main-page mt-10">
        <div v-if="logoutSplash" class="logout-splash">
         <span>{{ logoutMessage }}</span>
        </div>
        <div class="main-container mt-10">
            <!-- FAQ -->
            <section id="faq" class="faq-section mb-5">
            <div class="head-title mb-4">
                <h2>
                <i class="fa fa-question-circle text-primary-tour mr-2"></i>
                Frequently Asked Questions
                </h2>
            </div>

            <div class="accordion" id="faqAccordion">
                <div class="card mb-3" v-for="(faq, index) in faqs" :key="index">
                <div class="card-header" :id="'heading' + index">
                    <h5 class="mb-0">
                    <button
                        class="btn btn-link text-left w-100 d-flex justify-content-between align-items-center"
                        type="button"
                        data-toggle="collapse"
                        :data-target="'#collapse' + index"
                        aria-expanded="false"
                        :aria-controls="'collapse' + index"
                        style="font-weight: 700; font-family: 'Raleway';white-space: normal; word-break: break-word;"
                    >
                        {{ faq.question }}
                        <i class="fa fa-chevron-down"></i>
                    </button>
                    </h5>
                </div>

                <div
                    :id="'collapse' + index"
                    class="collapse"
                    :aria-labelledby="'heading' + index"
                    data-parent="#faqAccordion"
                >
                    <div class="card-body text-muted">
                    {{ faq.answer }}
                    </div>
                </div>
                </div>
            </div>
            </section>
        </div>   
        <page-loader :is-loading="isLoading"></page-loader>
    </div>
</template>
<script>
/* eslint-disable */ 
import Vue from 'vue'
import swal from 'sweetalert2';
import PaystackPop from '@paystack/inline-js';
import * as bootstrap from 'bootstrap'


export default {


data() {
  return {

    pageLoader: false,
    isLoading: false,
    image_path: '',
    find_match: true,
    your_match: false,
    filtering: false,
    filtering2: false,
    nextOption: false,
    chatUser: false,
    viewMatchProfile: false,
    response: '',
    location: '',
    religion: '',
    male: '',
    female: '',
    value: [0, 100],
    user_profile: [],
    profile_pictures: [],
    view_profile: [],
    user_ages: [],
    view_age: '',
    show_profile: [],
    show_age: '',
    options: [],
    match_status: '',
    match_profile: [],
    match_pictures: [],
    match_ages: [],
    show_picture: '',
    valuex: 0,
    is_nigeria: false,
    user_country: '',
    country_dial_code:'',
    country_iso2: '',
    choose_game: false,
    choose_credittype: false,
    user_email: '',
    apikey:'',
    fees: 0,
    regular: 0,
    silver: 0,
    gold: 0,
    package: 0,
    package_name: '',
    list_escorts: [],
    list_rooms: [],
    states: [],
    state: '',

    boostedEscorts: [],
    escortsOnTour: [],

    faqs: [],
    escort_video: [],
    userId: '',
    logoutSplash: false,
    logoutMessage: "",
    selectedPlan: '',
    selectedFee: '',
    selectedId: '',
    showModels: false,
    selectedNumber: null,
    selectedModel: '',
    showModal: true
    
  };
},

beforeMount(){
   
},

async mounted(){
    this.user_email = localStorage.getItem("email");
    this.userId = localStorage.getItem("userid"); 

   await this.getConfigData()
   await this.fetchEscorts()
   await this.fetchBoostedEscorts()
   await this.fetchEscortsOnTour()
   await this.listEscortVideos()
   await this.listFaqs();
   await this.getStates();
   
},
computed: {
    firstHalf() {
      const mid = Math.ceil(this.boostedEscorts.length / 2);
      return this.boostedEscorts.slice(0, mid);
    },
    secondHalf() {
      const mid = Math.ceil(this.boostedEscorts.length / 2);
      return this.boostedEscorts.slice(mid);
    }
  },

methods: {
    closeMainModal() {
        this.showModal = false;
    },
    openContactModal(number, username) {
      this.selectedNumber = number;
      this.selectedModel = username;
      const modal = new bootstrap.Modal(document.getElementById('contactModal'));
      modal.show();
    },
    dialNumber(number) {
      window.location.href = `tel:${number}`;
    },
    whatsappNumber(number) {
      const cleanNumber = number.replace(/\D/g, '');
      window.open(`https://wa.me/${cleanNumber}`, '_blank');
    },
    searchModels(){
        !this.showModels ? this.showModels = true : this.showModels = false
    },
    maskPhoneNumber(phone) {
        if (!phone) return '';
        return phone.slice(0, 4) + '*'.repeat(phone.length - 4);
    },

    async getConfigData(){
        const response = await fetch('/config.json');
        const configData = await response.json();
        this.apikey = configData.apikey;
    },

    formatPrice(price) {
    return new Intl.NumberFormat('en-NG', {
      style: 'currency',
      currency: 'NGN',
      minimumFractionDigits: 2
    }).format(price);
  },

    onSelect({name, iso2, dialCode}) {
       this.country_iso2 = iso2
       this.user_country = name
       this.country_dial_code = dialCode
     },
    
    async listEscortVideos(){
         try{

            const response = await this.$http.get('/list-all-videos',{} )
            this.escort_video = response.data.data;

            }catch (err) {
                console.log(err);
            }
    },

    async getStates() {
    try{
        const response = await this.$http.get('state/fetch',{

            headers: { 
                "x-api-key": `${process.env.VUE_APP_API_KEY}`,
                'Content-Type': 'application/json' 
               },
        } )
        this.states = response.data.states;

        }catch (err) {
            console.log(err);
        }
    },

    async viewProfile(e) {
        // eslint-disable-next-line
        try{
            
        //this.filtering = true
        this.response = await this.$http.post('/getprofile', {
            userid: e,
        });

        //this.filtering = false

        if (!this.response.data.success) {
            swal.fire({
                title: 'success',
                width:350,
                height:3,
                text: this.response.data.message,
                });
                return;

            } else {

                this.view_profile = this.response.data.profile_detail;
                this.view_age = this.response.data.age;
                this.match_status = this.response.data.match_status;
                this.nextOption = true

        }
                            
        }catch (err) {
            console.log(err);
        }

    },

    async showProfile(e) {
        // eslint-disable-next-line
        try{
            
        //this.filtering = true
        this.response = await this.$http.post('/getprofile', {
            userid: e,
        });

        //this.filtering = false

        if (!this.response.data.success) {
            swal.fire({
                title: 'success',
                width:350,
                height:3,
                text: this.response.data.message,
                });
                return;

            } else {

                this.show_profile = this.response.data.profile_detail;
                this.show_age = this.response.data.age;
                this.match_status = this.response.data.match_status;
                this.show_picture = this.response.data.picture;
                this.viewMatchProfile = true

        }
                            
        }catch (err) {
            console.log(err);
        }

    },

    async match(e) {
        // eslint-disable-next-line
        try{
            
        this.filtering2 = true
        this.response = await this.$http.post('/match-profile', {
            userid: e,
        });

        this.filtering2 = false

        if (!this.response.data.success) {
            swal.fire({
                title: 'success',
                width:350,
                height:3,
                text: this.response.data.message,
                });
                return;

            } else {

                this.match_status = this.response.data.match_status;                

        }
                            
        }catch (err) {
            console.log(err);
        }

    },

    async unmatch(e) {
        // eslint-disable-next-line
        try{
            
        this.filtering2 = true
        this.response = await this.$http.post('/unmatch-profile', {
            userid: e,
        });

        this.filtering2 = false

        if (!this.response.data.success) {
            swal.fire({
                title: 'success',
                width:350,
                height:3,
                text: this.response.data.message,
                });
                return;

            } else {

                this.match_status = this.response.data.match_status;                

        }
                            
        }catch (err) {
            console.log(err);
        }

    },

    findMatch() {
        this.find_match = true
        this.your_match = false

        var t = document.getElementsByClassName("your-matches");
        t[0].style.backgroundColor = "transparent";
        t[0].style.borderBottom = "1px solid #000";

        var ts = document.getElementsByClassName("pyour-match");
        ts[0].style.color = "#767475";

        var r = document.getElementsByClassName("find-match");
        r[0].style.backgroundColor = "#1E1D20";
        r[0].style.marginTop="-10px";
        r[0].style.borderBottom = "1px solid #D33E74";
        r[0].style.padding = "15px";
        r[0].style.height ="70px";
        
        var rs = document.getElementsByClassName("pfind-match");
        rs[0].style.color = "#D33E74";
        rs[0].style.textAlign = "center";
    },

    yourMatch() {
        this.find_match = false
        this.your_match = true
        this.loadMatchProfile()
        var t = document.getElementsByClassName("find-match");
        t[0].style.backgroundColor = "transparent";
        t[0].style.borderBottom = "1px solid #000";

        var ts = document.getElementsByClassName("pfind-match");
        ts[0].style.color = "#767475";

        var r = document.getElementsByClassName("your-matches");
        r[0].style.backgroundColor = "#1E1D20";
        r[0].style.marginTop="-10px";
        r[0].style.borderBottom = "1px solid #D33E74";
        r[0].style.padding = "15px";
        r[0].style.height ="70px";
        
        var rs = document.getElementsByClassName("pyour-match");
        rs[0].style.color = "#D33E74";
        rs[0].style.textAlign = "center";
    },

    hide(x) {
        var t = document.getElementsByClassName("photo-footer1"+x);
        t[0].style.display = "block";

        var s = document.getElementsByClassName("photo-footer"+x);
        s[0].style.display = "none";
       
    },

    unhide(x) {
        var t = document.getElementsByClassName("photo-footer"+x);
        t[0].style.display = "block";

        var s = document.getElementsByClassName("photo-footer1"+x);
        s[0].style.display = "none";
       
    },

    async fetchEscorts(){
         try{

            this.isLoading = true

            this.response = await this.$http.get('/list-escorts', {
            });

            this.isLoading = false

            this.list_escorts = this.response.data.data;
                                  
            }catch (err) {
                console.log(err)
                // swal.fire({
                //     title: 'Error',
                //     width:250,
                //     height:2,
                //     text: err.response ? err.response.data.message : err.message,
                // });
        }
    },

    async searchProfile() {
    const gender = this.female ? 'Female' : (this.male ? 'Male' : null);
    const minAge = this.value[0];
    const maxAge = this.value[1];

    try {
      const escorts = await this.$http.post('/search-escorts', {
        country: this.selectedCountry?.name || null,
        state: this.state || null,
        location: this.location || null,
        gender,
        minAge,
        maxAge
      });

      this.list_escorts = escorts.data.data;
    } catch (err) {
        swal.fire({
            icon: "error",
            title: 'Error',
            width:450,
            height:2,
            text: err.response ? err.response.data.message : err.message,
        });
      console.error('Search failed:', err);
    }
    },

    async fetchBoostedEscorts(){
         try{

            this.pageLoader = true
            //this.filtering = true
            this.response = await this.$http.get('/list-boosted-escorts', {
            });

            //this.filtering = false
            this.pageLoader = false

            this.boostedEscorts = this.response.data.data;
                                  
            }catch (err) {
                console.log(err)
                // swal.fire({
                //     title: 'Error',
                //     width:250,
                //     height:2,
                //     text: err.response ? err.response.data.message : err.message,
                // });
        }
    },

    async fetchEscortsOnTour(){
         try{

            this.response = await this.$http.get('/list-escorts-ontour', {
            });

            this.escortsOnTour = this.response.data.data;
                                  
            }catch (err) {
                console.log(err)
                // swal.fire({
                //     title: 'Error',
                //     width:250,
                //     height:2,
                //     text: err.response ? err.response.data.message : err.message,
                // });
        }
    },
    async listFaqs(){
         try{

            this.response = await this.$http.get('/list-faqs', {
            });

            this.faqs = this.response.data.data;
                                  
            }catch (err) {
                console.log(err)
        }
    },

     // eslint-disable-next-line
     message(e) {
        this.chatUser = true
        this.user_id = e
    },

    async sendMessage(){
        try{
            
            this.message_status = true
            this.response = await this.$http.post('/send-message2', {
                userid: this.user_id,
                message: this.user_message
            });
    
            this.message_status = false
    
            if (!this.response.data.success) {
                swal.fire({
                    title: 'error',
                    width:350,
                    height:3,
                    text: this.response.data.message,
                    });
                    return;
    
                } else {
    
                    swal.fire({
                        icon: 'success',
                        title: 'Message',
                        width:450,
                        height:5,
                        text: this.response.data.message,
                    });
                    this.chatUser = false
                    return;              
    
            }
                                
            }catch (err) {
                console.log(err);
        }
    },

    // game mode
    async gameMode() {
        try{
            const response = await this.$http.post('/check-gamemode', {
                app_category: 2,
            });
            this.apikey = response.data.apikey
            this.regular = response.data.regular_fee
            this.silver = response.data.silver_fee
            this.gold = response.data.gold_fee
        if (!response.data.success) {
                this.choose_game = true;
            } else {
                this.choose_game = false;
                this.apikey = response.data.apikey
                this.regular = response.data.regular_fee
                this.silver = response.data.silver_fee
                this.gold = response.data.gold_fee
            }               
        }catch (err) {
            console.log(err);
        }
    },

    async choose_gametype(x, amount, y, z) {
    if( x == 1 ) {
        const response = await this.$http.post('/choose-game', {
            game_mode: x,
            userid: this.user_id,
            app_category: 2,
        });

        if (!response.data.success) {
                this.choose_game = false;
                return;
            } else {

                this.paid = response.data.paid

                if(this.paid == 0){
                    this.choose_game = false;
                    this.choose_credittype = true;
                    this.fees = amount;
                    this.package = y;
                    this.package_name = z;
                }
                else if(this.paid == 1) {
                    this.choose_game = false;
                    this.choose_credittype = false;
                    this.game_type_status = x;
                }
                return;              
            }
        }
        else if( x == 2 ) {
            this.choose_game = false;
            this.game_type_status = x;
        }
        else if( x == 3 ) {
            this.choose_credittype = false;
            this.game_type_status = x;
            this.$router.push('/home');
        }
    },

    makePayment(){
        const paystack = new PaystackPop();

        paystack.newTransaction({
            key: this.apikey,
            email: this.user_email,
            amount: this.selectedFee+"00",

            onSuccess: (transaction) => { 
                // Payment complete! Reference: transaction.reference 
                this.payment_ref = transaction.reference 
                this.pay(this.payment_ref)
            },
            onCancel: () => {
                // user closed popup
            }
        });
    },

    async pay(payment_reference) {
        try{
            this.response = await this.$http.post('/create-client-subscription', {
                user_id: this.userId,
                plan_id: this.selectedId,
                payment_reference: payment_reference
            });

        if (!this.response.data.success) {
                // Set splash message
                this.logoutMessage  = this.response.data.message || "Payment not successful!";
                this.logoutSplash = true

                // Wait before redirecting
                setTimeout(() => {
                    this.logoutSplash = false;
                        
                    }, 2500); // splash visible for 2.5 seconds
                return;

            } else {

            // Set splash message
            this.logoutMessage = this.response.data.message || "Payment successful!";
            this.logoutSplash = true;
            // Wait before redirecting
            setTimeout(() => {
                this.logoutSplash = false
                this.choose_credittype = false
                alert(`Subscription plan "${this.selectedPlan}" activated!`);    
            }, 2500); // splash visible for 2.5 seconds
            return;           
        }
                            
        }catch (err) {
            console.log(err);
        }

    },

    subscribe(planId, planName, planFee) {
        if (!this.userId) {
        // Set splash message
        this.logoutMessage = "Please login to subscribe for a package!";
        this.logoutSplash = true;
        // Wait before redirecting
        setTimeout(() => {
                this.$router.push('/login');
                
            }, 2500); // splash visible for 2.5 seconds
            return;
        }
        this.choose_credittype = true
        this.selectedFee = planFee
        this.selectedPlan = planName
        this.selectedId = planId
    },
  }
}

</script>
<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans&family=Raleway&display=swap');
.video-scroll {
  display: flex;
  overflow-x: auto;
  gap: 1rem;
  padding: 1rem;
  scroll-behavior: smooth;
  white-space: nowrap;
}

.video-scroll::-webkit-scrollbar {
  height: 8px;
}

.video-scroll::-webkit-scrollbar-thumb {
  background-color: #666;
  border-radius: 10px;
}

.video-scroll::-webkit-scrollbar-thumb:hover {
  background-color: #444;
}

.escort-card-wrapper-v {
  flex: 0 0 auto;
  width: 220px; /* Adjust card width */
  border-radius: 10px;
  background: #222;
}

.custom-img {
  width: 100%;
  height: 160px;
  object-fit: cover;
  border-radius: 10px;
}


@media (max-width: 576px) {
    .search-section{
        margin-top: 70px;
    }
}
.btn-link{
    color: #D33E74 !important; /* red warning */
}
.btn-link:hover{
    color: #333 !important;
}
.age-info {
  margin-top: 15px;
  font-size: 14px;
  color: #d9534f; /* red warning */
  font-weight: bold;
}
/* Overlay */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

/* Modal Box */
.modal-content {
  background: #fff;
  border-radius: 12px;
  max-width: 450px;
  width: 90%;
  padding: 24px;
  text-align: center;
  animation: fadeIn 0.3s ease-in-out;
}

/* Title & Description */
.modal-title {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 12px;
}
.modal-desc {
  font-size: 0.95rem;
  margin-bottom: 20px;
}

/* Badge Info Row */
.badge-container-info {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 10px 0;
  font-size: 0.95rem;
}

@media (max-width: 576px) {
    .badge-container-info {
        gap: 2px;
        margin: 2px 0;
        font-size: 0.80rem;
    }
}
.badge-content {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  display: inline-block;
}
.blue-badge {
  background-color: #007bff;
}
.green-badge {
  background-color: #28a745;
}

/* Button */
.modal-btn {
  margin-top: 15px;
  padding: 10px 20px;
  background: #007bff;
  border: none;
  border-radius: 6px;
  color: #fff;
  cursor: pointer;
  font-size: 0.95rem;
  transition: background 0.2s;
}
.modal-btn:hover {
  background: #0056b3;
}

/* Animation */
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
}

.phone-circle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 15px;  /* circle size */
  height: 15px;
  border-radius: 50%;
  background-color: #28a745; /* green */
  color: white;
  font-size: 10px;
  cursor: pointer;
}

.phone-circle:hover {
  background-color: #218838; /* darker green on hover */
}

.escort-slogan{
    line-height: 1.2px;
    color: #D33E74;
    text-transform: capitalize;
    font-size: 12px;
}

.tour-username{
    font-size: 13px;
    font-weight: 700;
}
.tour-city{
    font-size: 13px;
    font-weight: 700;
}
.tour-date{
    font-size: 13px;
    font-weight: 700;
}
/* Make modal small and neat */
.modal-sm {
  max-width: 300px;
  width: 100%; /* Fill screen up to max-width */
  margin-left: auto;
  margin-right: auto;
}

/* Extra: On very small screens, add a little side padding */
@media (max-width: 576px) {
  .modal-dialog {
    margin: 0.5rem auto;
  }
}

.contact-modal {
  border-radius: 12px;
  box-shadow: 0 5px 20px rgba(0,0,0,0.15);
  padding-bottom: 10px;
  background: #0A070F;
  color: #fff;
}

.contact-number {
  font-size: 1rem;
  font-weight: 500;
  margin-bottom: 15px;
  color: #fff;
}

.btn {
  border-radius: 8px;
}

.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.4s ease-in-out;
  opacity: 0.1;
}

.fade-slide-enter-from,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.logout-splash {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  font-family: 'Raleway';
  font-style: normal;
  background-color: #0A070F; /* green success */
  color: white;
  padding: 15px;
  text-align: center;
  font-weight: bold;
  z-index: 9999;
  box-shadow: 0 2px 5px rgba(0,0,0,0.3);
  transition: top 0.3s ease-in-out;
}

.banner-section{
    background: #111112;
    border-radius: 10px;
}
.banner-top{
    padding: 4px 0 0 4px;
    color: #fff !important;
}
.banner{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}
.banner-slide {
  position: relative;
  width: 100%;
  height: 100%;
}

.escort-img {
  width: 100%;
  aspect-ratio: 4 / 5;
  object-fit: cover;
  border-radius: 0px;
}

.escort-banner-img {
  width: 100%;
  height: 100%;
  object-fit:cover;
}

.escort-banner-overlay {
  position: absolute;
  bottom: 15px;
  left: 20px;
  color: #fff;
  background: rgba(0, 0, 0, 0.4);
  padding: 10px 15px;
  border-radius: 6px;

  h4{
    font-weight: bold;
    font-size: 15px;
    line-height: 3px;
  }
  p{
    font-size: 12px;
    line-height: 2px;
  }
  .phone{
    font-size: 12px;
    margin-top: -10px;
  }
}


.main-page {
    padding: 10px 10px 60px 20px;
    width: 100%;
    min-height: 100vh;
}
.main-container{
    width:100%;
}
.loader{
    width:100%;
    height:300px;
    display:flex;
    align-items:center;
    justify-content:center;
    gap:20px;
  }
  
  .dot{
    height:40px;
    width:40px;
    border-radius:50%;
  }
  
  .dot:nth-child(1){
    background-color:red;
    animation: jump 0.6s 0.5s ease-in infinite
  }
  .dot:nth-child(2){
    background-color:blue;
    animation: jump 0.6s 0.7s ease-in infinite
  }
  .dot:nth-child(3){
    background-color:orange;
    animation: jump 0.6s 0.9s ease-in infinite
  }
  
  .btn-outline-primary{
    background: #D33E74;
    color: #fff;
    border: solid 0;
  }
  .btn-outline-primary:hover{
    background: #D33E74;
    color: #333;
  }
  .text-primary-tour{
    text-align: center;
    color: #D33E74 !important;
  }
  
  @keyframes jump{
    0%{
      transform: translate3D(0,0,0);
      opacity: 0;
    }
      50%{
      transform: translate3D(0,-15px,0);
        opacity: 0.5;
    }
      100%{
      transform: translate3D(0,0,0);
        opacity: 1;
    }
  }
 .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .4s ease;
    & > div {
        //width: 100%;
        height: 520px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        //padding: 2em;
        border: 1px solid #2F2F2F;
        //backdrop-filter: blur(13px);
        background: #19181B;
        border-radius: 20px;
        box-sizing: border-box;
      }
      .profile-view2{
        box-sizing: border-box;
        border-radius: 20px;
        //position:relative;
        width: 100%;
        height: 100%;
        //background: #111112;

        .profile-photo2{
            width: 100%;
            height: auto;
            background: linear-gradient(180deg, rgba(0, 0, 0, 0.25) 59.17%, rgba(0, 0, 0, 0.5) 80.14%), #2F2F2F;
        }
    }
    .profile-info2 {
    padding: 1rem 2rem 2rem 1rem;

        h3{
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 800;
            font-size: 20px;
            line-height: 24px;
            text-align: left;
            color: #FFFFFF;
            margin-left: 20px;
        }
        p {
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            line-height: 10px;
            text-align: left;
            color: #767475;
            margin-left: 20px;
        }
    }
    .profile-bio2{
        
        P {
            width: auto;
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 154.2%;
            color: #767475;;
            text-align: left;
            margin:20px;
        }

    }
    .profile-interest2{
        
        h3 {
            width: auto;
            height: 26px;
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 700;
            font-size: 20px;
            line-height: 26px;
            text-align: left;
            color: #FFFFFF;
            margin:20px;
        }
        .interests2{
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 2px 8px;
            width: auto;
            height: 29px;
            background: #111112;
            border: 1px solid #D33E74;
            border-radius: 50px;
            color: #767475;
            font-size: 10px;
            font-family: 'DM Sans';
            margin: 4px;

        }

        .interests-info2 {
            display: flex;
            flex-direction: row;
            //padding: 0rem 3rem 5rem 1rem;
        }
    }
    .profile-relationship-goal2{
        margin-top: -150px !important;
        h3 {
            width: auto;
            height: 26px;
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 700;
            font-size: 20px;
            line-height: 26px;
            text-align: left;
            color: #FFFFFF;
            margin:20px;
        }
        .relationship-goal2 {
            display: flex;
            flex-direction: row;
            padding: 2px;
            width: 70%;
            height: auto;
            background: rgba(255, 214, 0, 0.1);
            border-radius: 61px;
            color: #FFD600;
            font-size: 10px;
            font-family: 'DM Sans';
            margin: 20px;
            text-align: left;
        }

    }
    .btn-unmatch-report2 {
        display: flex;
        flex-direction: row;
        align-items: center;
        .btn-unmatch2 {
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 10px;
            width: 55%;
            height: 30px;
            background: #111112;
            border: 1px solid #D33E74;
            border-radius: 82px;
            font-family: 'Source Sans 3';
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            line-height: 28px;
            color: #D33E74;
            margin: 20px;
            cursor: pointer;
        }
        .btn-unmatch3 {
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 10px;
            width: 55%;
            height: 30px;
            background: #111112;
            border: 1px solid #D33E74;
            border-radius: 82px;
            font-family: 'Source Sans 3';
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            line-height: 28px;
            color: #b1acae;
            margin: 20px;
            cursor: pointer;
        }
        .btn-report2 {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 10px;
            width: 55%;
            height: 30px;
            background: #2D2D2D;
            border-radius: 82px;
            font-family: 'Source Sans 3';
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            line-height: 28px;
            color: #767475;
            margin-right: 10px;
            cursor: pointer;
        }
    }
  }
  .modal-masky {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .4s ease;
    & > div {
        //width: 100%;
        height: 200px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        //padding: 2em;
        border: 1px solid #2F2F2F;
        //backdrop-filter: blur(13px);
        background: #19181B;
        border-radius: 20px;
        box-sizing: border-box;
      }
      .profile-view2{
        box-sizing: border-box;
        border-radius: 20px;
        //position:relative;
        width: 100%;
        height: 100%;
       // background: #111112;

        .profile-photo2{
            width: 100%;
            height: auto;
            background: linear-gradient(180deg, rgba(0, 0, 0, 0.25) 59.17%, rgba(0, 0, 0, 0.5) 80.14%), #2F2F2F;
        }
    }
    .profile-info2 {
    padding: 1rem 2rem 2rem 1rem;

        h3{
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 800;
            font-size: 20px;
            line-height: 24px;
            text-align: left;
            color: #FFFFFF;
            margin-left: 20px;
        }
        p {
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            line-height: 10px;
            text-align: left;
            color: #767475;
            margin-left: 20px;
        }
    }
    .profile-bio2{
        
        P {
            width: auto;
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 154.2%;
            color: #767475;;
            text-align: left;
            margin:20px;
        }

    }
    .profile-interest2{
        
        h3 {
            width: auto;
            height: 26px;
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 700;
            font-size: 20px;
            line-height: 26px;
            text-align: left;
            color: #FFFFFF;
            margin:20px;
        }
        .interests2{
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 2px 8px;
            width: auto;
            height: 29px;
            background: #111112;
            border: 1px solid #D33E74;
            border-radius: 50px;
            color: #767475;
            font-size: 10px;
            margin: 4px;

        }
        .interests-info2 {
            display: flex;
            flex-direction: row;
            //padding: 0rem 3rem 5rem 1rem;
        }
    }
    .profile-relationship-goal2{
        margin-top: -150px !important;
        h3 {
            width: auto;
            height: 26px;
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 700;
            font-size: 20px;
            line-height: 26px;
            text-align: left;
            color: #FFFFFF;
            margin:20px;
        }
        .relationship-goal2 {
            display: flex;
            flex-direction: row;
            padding: 2px;
            width: 70%;
            height: auto;
            background: rgba(255, 214, 0, 0.1);
            border-radius: 61px;
            color: #FFD600;
            font-size: 10px;
            margin: 20px;
            text-align: left;
        }

    }
    .btn-unmatch-report2 {
        display: flex;
        flex-direction: row;
        align-items: center;
        .btn-unmatch2 {
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 10px;
            width: 55%;
            height: 30px;
            background: #111112;
            border: 1px solid #D33E74;
            border-radius: 82px;
            font-family: 'Source Sans 3';
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            line-height: 28px;
            color: #D33E74;
            margin: 20px;
            cursor: pointer;
        }
        .btn-unmatch3 {
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 10px;
            width: 55%;
            height: 30px;
            background: #111112;
            border: 1px solid #D33E74;
            border-radius: 82px;
            font-family: 'Source Sans 3';
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            line-height: 28px;
            color: #b1acae;
            margin: 20px;
            cursor: pointer;
        }
        .btn-report2 {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 10px;
            width: 55%;
            height: 30px;
            background: #2D2D2D;
            border-radius: 82px;
            font-family: 'Source Sans 3';
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            line-height: 28px;
            color: #767475;
            margin-right: 10px;
            cursor: pointer;
        }
    }
  }
    .modal-maskp {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .4s ease;
        
        & > div {
            width: 80%;
            height: auto;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            //padding: 2em;
            border: 0.5px solid #D33E74;
            background: #19181B;
            border-radius: 20px;
            box-sizing: border-box;
        }
    .player-title{
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 800;
        font-size: 24px;
        line-height: 42px;
        text-align: center;
        color: #FFFFFF;
    }
    .amount {
        display: flex;
        flex-direction: row;
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 13px;
        line-height: 19px;
        color: #FFFFFF;
        justify-content: space-between;
        .fees {
            
        }
        .price {
        
            font-family: 'Nunito';
            font-style: normal;
            font-weight: 700;
            font-size: 18px;
            line-height: 27px;
            color: #D33E74;
        }
    }
    .payment-option{
        display: flex; 
        flex-direction: row; 
    }
    .payment-types {
        width: 388px;
        height: 254px;
        background: #272528;
        border-radius: 8px;
        cursor: pointer;
        margin-bottom:20px;
        .payhow{
            font-family: 'Nunito';
            font-style: normal;
            font-weight: 700;
            font-size: 12px;
            line-height: 10px;
            letter-spacing: -0.02em;
            color: #FFFFFF;
            text-align: center;
            margin-top: 10px;
        }
        .payment{
            margin:15px;
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            align-items: center;
            padding: 0px 14px;
            width: 314px;
            height: 46px;
            background: #19181B;
            border-radius: 4px;
            font-family: 'Nunito';
            font-style: normal;
            font-weight: 600;
            font-size: 13px;
            line-height: 22px;
            letter-spacing: -0.02em;
            color: #FFFFFF;
        }

        h3{
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 700;
            font-size: 20px;
            line-height: 42px;
            text-align: center;
            color: #0A070F;
        }
        
        
    }
    .player-payinfo{
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 13px;
        text-align: center;
        color: #FFFFFF;
        display: block;
        margin-left: auto;
        margin-right: auto;
    }
    .player-button{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 5px;
        height: auto;
        width: 40px;
        background: #333;
        border-radius: 5px;
        font-family: 'Source Sans 3';
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        color: #FFFFFF;
        margin-top: 10px;
        margin-bottom: 30px;
        //display: block;
        margin-left: auto;
        margin-right: auto;
    }   
    }

    .modal-maskyx {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .4s ease;

        & > div {
            width: 80%;
            height: auto;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            //padding: 2em;
            border: 0.5px solid #D33E74;
            background: #19181B;
            border-radius: 20px;
            box-sizing: border-box;
        }
    .player-title{
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 800;
        font-size: 24px;
        line-height: 42px;
        text-align: center;
        color: #FFFFFF;
    }
    .game-mode{
        display: flex; 
        flex-direction: column; 
    }
    .live-mode {
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        align-content: center;
        padding: 10px;
        width: 100%;
        height:50px;
        margin:4px;
        border: 1px solid #D33E74;
        border-radius: 4px;
        margin-right: 20px;
        cursor: pointer;

        h3{
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 700;
            font-size: 18px;
            line-height: 42px;
            text-align: center;
            color: #FFF;
        }
        p{
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 700;
            font-size: 13px;
            line-height: 1px;
            text-align: center;
            color: #FFF;
            margin-top: -10px;
        }
        
    }
    .live-mode:hover {
        background: #D33E74;

        P{
            color: #19181B;
        }
        h3{
            color: #19181B;
        }
    }
    .party-mode {
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 10px;
        width: 220px;
        height: 180px;
        background: #19181B;
        border: 1px solid #D33E74;
        border-radius: 27px;
        cursor: pointer;

        h3{
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 700;
            font-size: 20px;
            line-height: 42px;
            text-align: center;
            color: #FFFFFF;
        }
        p{
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 700;
            font-size: 10px;
            line-height: 12px;
            text-align: center;
            color: #FFFFFF;
            margin-top: -10px;
        }
    }
    .player-name{
        font-family: 'DM Sans';
        font-style: normal;
        font-weight: 700;
        font-size: 18px;
        line-height: 31px;
        text-align: center;
        color: #FFFFFF;

    }
    .player-payinfo{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-content: center;
        padding: 4px;
        width: 110%;
        height: 30px;
        background: rgba(211, 62, 116, 0.1);
        border-radius: 5px;
        font-family: 'DM Sans';
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 12px;
        text-align: center;
        color: #D33E74;
        margin-top: 20px;
        display: block;
        margin-left: auto;
        margin-right: auto;
        margin-bottom:20px


    }
    .player-button{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 5px;
        height: auto;
        background: #111112;
        border-radius: 5px;
        font-family: 'Source Sans 3';
        font-style: normal;
        font-weight: 600;
        font-size: 10px;
        line-height: 28px;
        color: #FFFFFF;
        margin-top: 10px;
        margin-bottom: 30px;
        display: block;
        margin-left: auto;
        margin-right: auto;
    }   
    }
  .modal-xl {
      width: 90%;
     max-width:1200px;
  }
 .modal-window {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 999;
    visibility: hidden;
    opacity: 0;
    pointer-events: none;
    transition: all 0.3s;
    &:target {
      visibility: visible;
      opacity: 1;
      pointer-events: auto;
    }
    & > div {
      width: 350px;
      height: 250px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      //padding: 2em;
      border: 1px solid #2F2F2F;
      backdrop-filter: blur(13px);
      background: #19181B;
      border-radius: 20px;
      box-sizing: border-box;
    }
    header {
      font-weight: bold;
    }
    h1 {
      font-size: 150%;
      margin: 0 0 15px;
    }
    h2 {
        margin-top: 50px;
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 24px;
        line-height: 23px;
        text-align: center;
        color: #FFFFFF;
    }
    label {
        text-align: left;
        color: #fff;
        font-size: 12px;
        margin-left:15px;
        margin-bottom: -6px;
    }
    span {
        margin-bottom: 20px;
    }

  }
  .login-modal-box {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px;
    margin-top: 10px;
    margin-left: 10px;
    background: #19181B;
    border: 0.5px solid #767475;
    border-radius: 50px;
    //width:500%;
  }
  .modal-close {
    color: #fff;
    line-height: 50px;
    font-size: 140%;
    position: absolute;
    right: 0;
    text-align: center;
    top: 2;
    width: 70px;
    text-decoration: none;
    &:hover {
      color: black;
    }
  }
  .btn-login {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px;
    gap: 10px;
    background: #D33E74;
    border-radius: 82px;
    margin-top: 8px;
    color: #fff;
    margin-left: 10px;
    
}
  .modal-close-mobile {
    color: #fff;
    line-height: 50px;
    font-size: 140%;
    position: absolute;
    right: 0;
    text-align: center;
    top: 2;
    width: 70px;
    text-decoration: none;
    &:hover {
      color: black;
    }
    display: none;
  }
    .tab {
    display: flex;
    flex-direction: row;
    text-align: center;
    width: 100%;

    .find-match {
        margin-top: -10px;
        width: 100%;
        height: 70px;
        background: #1E1D20;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;
        border-bottom: 1px solid #D33E74;

        p {
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 500;
            font-size: 20px;
            line-height: 28px;
            text-align: center;
            color: #D33E74;
        }
    }
    .your-matches {
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 20px;
        line-height: 28px;
        text-align: center;
        color: #767475;
    }

    }
    .find-match:hover {
        margin-top: -10px;
        width: 80px;
        height: 70px;
        background: #1E1D20;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;
        border-bottom: 1px solid #D33E74;
        cursor: pointer;
    }
    .your-matches:hover {
        margin-top: -10px;
        border-bottom: 1px solid #D33E74;
        background: #1E1D20;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;
        cursor: pointer;

        p {
            color: #D33E74;
        }
    }
    .navigation{
        padding: 20px 50px 50px 40px;
        margin-top: 30px;
        display: flex;
        flex-direction: row;

        .elipse{
            float: right;
            margin-left: 90%;
        }
    }
    .photo-row {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        position: relative;
        width: 100%;


        .margin{
            margin-top: 10px;
        }
        .overlay-info{
            background: #0a070f76 !important;
        }
        .escort-card {
        transition: transform 0.3s ease;
        background: #fff;
        border-radius: 12px;
        }

        .escort-card:hover {
        transform: translateY(-5px);
        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
        }

        .photo-footer{
            position: absolute;
            padding: 10px 0 0 15px;
            left: 0px;
            bottom: 0px;
            background: #1E1D20;
            opacity: 0.9;
            width: 100%;
            border-bottom-left-radius: 8px;
            border-bottom-right-radius: 8px;
            

            h3{
                .username{
                    margin-top: 8px;
                    font-family: 'DM Sans';
                    font-style: normal;
                    font-weight: 500;
                    font-size: 18px;
                    line-height: 5px;
                    text-align: left;
                    color: #D33E74;
                }
                .age{
                    margin-top: 8px;
                    font-family: 'DM Sans';
                    font-style: normal;
                    font-weight: 500;
                    font-size: 16px;
                    line-height: 5px;
                    text-align: left;
                    color: #FFFFFF;
                }
            }
            h6{
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 400;
                font-size: 13px;
                line-height: 0px;
                text-align: left;
                color: #FFFFFF;
            }
            span{
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 400;
                font-size: 13px;
                line-height: 0px;
                text-align: left;
                color: #FFFFFF;
            }
        }

        .escort-card-wrapper {
            border-radius: 0px;
            overflow: hidden;
            position: relative;
            transition: transform 0.3s ease;
           
        h6{
            font-size: 12px;
            font-weight: bold;
        }
        small{
            font-size: 12px;
        }
        }
       
        .escort-card-wrapper:hover {
        transform: translateY(-5px);
        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
        }


        .featured-badge {
        position: absolute;
        top: 10px;
        left: 10px;
        background: #ff4081;
        color: white;
        padding: 5px 10px;
        border-radius: 8px;
        font-size: 12px;
        z-index: 10;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
        }

    .verified-icon {
        margin-left: 5px;
        font-size: 16px;
        vertical-align: middle;
    }
    .text-success{
        color: #25D366 !important;
    }
        
    }
   
    .photo {
        //position: absolute;
        width: 100%;
        height: 100%;
        background: linear-gradient(180deg, rgba(0, 0, 0, 0.25) 59.17%, rgba(0, 0, 0, 0.5) 80.14%), #2F2F2F;
        border-radius: 20px;
        margin: 0px;
    }
    .profile-view{
        box-sizing: border-box;
        margin-top:30px;
        padding: 0rem 0rem 0rem 0rem;
        width: 120%;
        height: auto;
        background: #111112;

        .profile-photo {
            width: 100%;
            height: 200px;
            background: linear-gradient(180deg, rgba(0, 0, 0, 0.25) 59.17%, rgba(0, 0, 0, 0.5) 80.14%), #2F2F2F;
        }
    }
    .profile-info {
        padding: 1rem 2rem 2rem 1rem;

        h3{
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 800;
            font-size: 20px;
            line-height: 24px;
            text-align: left;
            color: #FFFFFF;
            margin-left: 20px;
        }
        p {
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            line-height: 10px;
            text-align: left;
            color: #767475;
            margin-left: 20px;
        }
    }
    .profile-bio{
        
        P {
            width: auto;
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 154.2%;
            color: #767475;;
            text-align: left;
            margin:20px;
        }

    }
    .profile-interest{
    
        h3 {
            width: auto;
            height: 26px;
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 700;
            font-size: 20px;
            line-height: 26px;
            text-align: left;
            color: #FFFFFF;
            margin:20px;
        }
        .interests{
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 2px 8px;
            width: auto;
            height: 29px;
            background: #111112;
            border: 1px solid #D33E74;
            border-radius: 50px;
            color: #767475;
            font-size: 10px;
            margin: 4px;

        }

        .interests-info {
            display: flex;
            flex-direction: row;
        }

    }
    .profile-relationship-goal{
        h3 {
            width: auto;
            height: 26px;
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 700;
            font-size: 20px;
            line-height: 26px;
            text-align: left;
            color: #FFFFFF;
            margin:20px;
        }
        .relationship-goal {
            display: flex;
            flex-direction: row;
            padding: 2px;
            width: 70%;
            height: auto;
            background: rgba(255, 214, 0, 0.1);
            border-radius: 61px;
            color: #FFD600;
            font-size: 10px;
            margin: 20px;
            text-align: left;
        }

    }
    .btn-unmatch-report {
        display: flex;
        flex-direction: row;
        align-items: center;
        .btn-unmatch {
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 10px;
            width: 55%;
            height: 30px;
            background: #111112;
            border: 1px solid #D33E74;
            border-radius: 82px;
            font-family: 'Source Sans 3';
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            line-height: 28px;
            color: #D33E74;
            margin: 20px;
            
        }
        .btn-unmatch3 {
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 10px;
            width: 55%;
            height: 30px;
            background: #111112;
            border: 1px solid #D33E74;
            border-radius: 82px;
            font-family: 'Source Sans 3';
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            line-height: 28px;
            color: #b1acae;
            margin: 20px;
            cursor: pointer;
        }
        .btn-report {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 10px;
            width: 55%;
            height: 30px;
            background: #2D2D2D;
            border-radius: 82px;
            font-family: 'Source Sans 3';
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            line-height: 28px;
            color: #767475;
            margin-right: 10px;
        }
    }

    .search-menu {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 100%;
       
        .location {
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding: 10px;
            width: 100%;
            height: 98px;
            background: #1E1D20;
            border-radius: 11px;
            margin: 4px;

            span {
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 400;
                font-size: 14px;
                line-height: 18px;
                text-align: left;
                color: #FFFFFF;
            }
            .input-location {
                display: flex;
                flex-direction: row;
                align-items: center;
                padding: 10px 17px;
                width: 100%;
                height: 37px;
                background: #1E1D20;
                border: 0.5px solid #767475;
                border-radius: 50px;
                font-family: 'Raleway';
                font-style: normal;
                font-weight: 500;
                font-size: 12px;
                line-height: 14px;
                /* identical to box height */
                text-align: center;
                color: #767475;
            }
        }
        .location-range {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 0px;
            width: 380px;
            height: 98px;
            background: #1E1D20;
            border-radius: 11px;
            margin: 4px;
            
            .range {
                display: flex;
                flex-direction: row;
                align-content: space-evenly;
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 400;
                font-size: 14px;
                line-height: 18px;
                color: #FFFFFF;
                padding: 0px 0 0 0;
                
                .men-women {
                    display: flex;
                    flex-direction: row;
                    align-content: space-between;

                    padding: 0rem 2rem 1rem 2rem;

                    .gender-content{
                        display: flex;
                        flex-direction: row;
                        align-content: left;
                        align-items: center;
                        width: 100%;

                        p {
                            margin-left: 0px;
                        }
                        .form-check-input{
                            background: #FFFFFF;
                            height: 20px;
                            width: 20px;

                        }
                        .form-check-input:checked{
                            background: #D33E74;
                            height: 22.5px;
                            width: 22.5px;
                        }
                    }
                    .men{
                        margin: 15px;
                    }
                    
                }
                .age-range {
                    width:100px;
                    //padding: 2rem 3rem 3rem 0rem;
                p {
                    margin-left: 20px;
                }
                .slider-bg{
                    background: #252426;
                    border-radius: 22px;
                }
               }
            }
        }
        .btn-filter-cancel {
            display: grid;
            flex-direction: column;
            margin: 2px;

            .btn-filter{
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                padding: 10px;
                width: 130px;
                height: 35px;
                background: #D33E74;
                border-radius: 82px;
                font-family: 'Source Sans 3';
                font-style: normal;
                font-weight: 400;
                font-size: 16px;
                line-height: 23px;
                color: #FFFFFF;
            }
            .btn-cancel{
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                padding: 10px;
                width: 130px;
                height: 35px;
                background: #2F2F2F;
                border-radius: 82px;
                border: 1px solid #D33E74;
                font-family: 'Source Sans 3';
                font-style: normal;
                font-weight: 400;
                font-size: 16px;
                line-height: 23px;
                color: #D33E74;
            }

        }
    }
    .head-title {
        
        h2{
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 900;
            font-size: 24px;
            line-height: 38px;
            text-align: left;
            color: #D33E74;
        }
        .models-search{
            color: white !important;
            cursor: pointer;
        }
        .models-search:hover{
            color: #D33E74 !important;
            border-bottom: 0.5px solid #fff; 
            width: 205px;
        }
       
    }
    /* Make image smaller on small screens (mobile) */
    @media (max-width: 576px) {
    .custom-img {
        height: 160px; /* adjust to desired size */
    }
    .escort-img {
        width: 100%;
        aspect-ratio: 3 / 6;
        border-radius: 0px !important;
    }
    }
    @media screen and (max-width: 700px) {
        .banner-section{
            margin-top: 120px;
        }
        .main-page {
            padding: 0px 0px 0px 0px;
        }
        .main-container{
            margin: 0px !important;
            width:100% !important;
        }


        .modal-mask {
            position: fixed;
            z-index: 9998;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, .5);
            display: table;
            transition: opacity .4s ease;
             & > div {
                 width: 80%;
                 height: 520px;
                 position: absolute;
                 top: 50%;
                 left: 50%;
                 transform: translate(-50%, -50%);
                 //padding: 2em;
                 border: 1px solid #2F2F2F;
                 //backdrop-filter: blur(13px);
                 background: #19181B;
                 border-radius: 20px;
                 box-sizing: border-box;
               }
         
               .profile-view2{
                 box-sizing: border-box;
                 border-radius: 20px;
                 //position:relative;
                 width: 100%;
                 height: 100%;
                // background: #111112;
         
                 .profile-photo2{
                     width: 100%;
                     height: auto;
                     background: linear-gradient(180deg, rgba(0, 0, 0, 0.25) 59.17%, rgba(0, 0, 0, 0.5) 80.14%), #2F2F2F;
                 }
             }
             .profile-info2 {
                  padding: 1rem 2rem 2rem 1rem;
         
                 h3{
                     font-family: 'Raleway';
                     font-style: normal;
                     font-weight: 800;
                     font-size: 20px;
                     line-height: 24px;
                     text-align: left;
                     color: #FFFFFF;
                     margin-left: 20px;
                 }
                 p {
                     font-family: 'DM Sans';
                     font-style: normal;
                     font-weight: 400;
                     font-size: 13px;
                     line-height: 10px;
                     text-align: left;
                     color: #767475;
                     margin-left: 20px;
                 }
             }
             .profile-bio2{
                 
                 P {
                     width: auto;
                     font-family: 'DM Sans';
                     font-style: normal;
                     font-weight: 400;
                     font-size: 12px;
                     line-height: 154.2%;
                     color: #767475;;
                     text-align: left;
                     margin:20px;
                 }
         
             }
             .profile-interest2{
                 
                 h3 {
                     width: auto;
                     height: 26px;
                     font-family: 'DM Sans';
                     font-style: normal;
                     font-weight: 700;
                     font-size: 20px;
                     line-height: 26px;
                     text-align: left;
                     color: #FFFFFF;
                     margin:20px;
                 }
                 .interests2{
                     box-sizing: border-box;
                     display: flex;
                     flex-direction: row;
                     justify-content: center;
                     align-items: center;
                     padding: 2px 8px;
                     width: auto;
                     height: 29px;
                     background: #111112;
                     border: 1px solid #D33E74;
                     border-radius: 50px;
                     color: #767475;
                     font-size: 10px;
                     margin: 4px;
         
                 }
         
                 .interests-info2 {
                     display: flex;
                     flex-direction: row;
                     //padding: 0rem 3rem 5rem 1rem;
                 }
             }
             .profile-relationship-goal2{
                 margin-top: -150px !important;
                 h3 {
                     width: auto;
                     height: 26px;
                     font-family: 'DM Sans';
                     font-style: normal;
                     font-weight: 700;
                     font-size: 20px;
                     line-height: 26px;
                     text-align: left;
                     color: #FFFFFF;
                     margin:20px;
                 }
                 .relationship-goal2 {
                     display: flex;
                     flex-direction: row;
                     padding: 2px;
                     width: 70%;
                     height: auto;
                     background: rgba(255, 214, 0, 0.1);
                     border-radius: 61px;
                     color: #FFD600;
                     font-size: 10px;
                     margin: 20px;
                     text-align: left;
                 }
         
             }
             .btn-unmatch-report2 {
                 display: flex;
                 flex-direction: row;
                 align-items: center;
                 .btn-unmatch2 {
                     box-sizing: border-box;
                     display: flex;
                     flex-direction: row;
                     justify-content: center;
                     align-items: center;
                     padding: 10px;
                     width: 55%;
                     height: 30px;
                     background: #111112;
                     border: 1px solid #D33E74;
                     border-radius: 82px;
                     font-family: 'Source Sans 3';
                     font-style: normal;
                     font-weight: 400;
                     font-size: 13px;
                     line-height: 28px;
                     color: #D33E74;
                     margin: 20px;
                 }
                 .btn-report2 {
                     display: flex;
                     flex-direction: row;
                     justify-content: center;
                     align-items: center;
                     padding: 10px;
                     width: 55%;
                     height: 30px;
                     background: #2D2D2D;
                     border-radius: 82px;
                     font-family: 'Source Sans 3';
                     font-style: normal;
                     font-weight: 400;
                     font-size: 13px;
                     line-height: 28px;
                     color: #767475;
                     margin-right: 10px;
                     cursor: pointer;
                 }
             }
        }
        .modal-xl {
              width: 90%;
              max-width:1200px;
        }
        .modal-maskp {
            position: fixed;
            z-index: 9998;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, .5);
            display: table;
            transition: opacity .4s ease;
            
            & > div {
                width: 80%;
                height: auto;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                //padding: 2em;
                border: 0.5px solid #D33E74;
                background: #19181B;
                border-radius: 20px;
                box-sizing: border-box;
            }
        .player-title{
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 800;
            font-size: 24px;
            line-height: 42px;
            text-align: center;
            color: #FFFFFF;
        }
        .amount {
            display: flex;
            flex-direction: row;
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 500;
            font-size: 13px;
            line-height: 19px;
            color: #FFFFFF;
            justify-content: space-between;
            .fees {
                
                font-family: 'Nunito';
                font-style: normal;
                font-weight: 700;
                font-size: 12px;
            }
            .price {
                
                font-family: 'Nunito';
                font-style: normal;
                font-weight: 700;
                font-size: 12px;
                line-height: 27px;
                color: #D33E74;
            }
        }
        .payment-option{
            display: flex; 
            flex-direction: row; 
        }
        .payment-types {
            width: 100%;
            height: 254px;
            background: #272528;
            border-radius: 8px;
            cursor: pointer;
            .payhow{
                font-family: 'Nunito';
                font-style: normal;
                font-weight: 700;
                font-size: 12px;
                line-height: 10px;
                letter-spacing: -0.02em;
                color: #FFFFFF;
                text-align: center;
                margin-top: 10px;
            }
            .payment{
                margin:15px;
                box-sizing: border-box;
                display: flex;
                flex-direction: row;
                align-items: center;
                padding: 0px 14px;
                width: 90%;
                height: 46px;
                background: #19181B;
                border-radius: 4px;
                font-family: 'Nunito';
                font-style: normal;
                font-weight: 600;
                font-size: 11px;
                line-height: 22px;
                letter-spacing: -0.02em;
                color: #FFFFFF;
            }
    
            h3{
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 700;
                font-size: 20px;
                line-height: 42px;
                text-align: center;
                color: #0A070F;
            }
            
            
        }
        .player-payinfo{
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 500;
            font-size: 11px;
            line-height: 14px;
            text-align: center;
            color: #FFFFFF;
            display: block;
            margin-left: auto;
            margin-right: auto;
        }
       
        }

        .modal-maskyx {
            position: fixed;
            z-index: 9998;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, .5);
            display: table;
            transition: opacity .4s ease;
    
            & > div {
                width: 80%;
                height: auto;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                //padding: 2em;
                border: 0.5px solid #D33E74;
                background: #19181B;
                border-radius: 20px;
                box-sizing: border-box;
            }
        .player-title{
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 800;
            font-size: 24px;
            line-height: 42px;
            text-align: center;
            color: #FFFFFF;
        }
        .game-mode{
            display: flex; 
            flex-direction: column; 
        }
        .live-mode {
            display: flex;
            flex-direction: column;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            align-content: center;
            padding: 10px;
            width: 100%;
            height: 50px;
            background: #D33E74;
            border: 1px solid #D33E74;
            border-radius: 10px;

            cursor: pointer;
    
            h3{
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 700;
                font-size: 16px;
                line-height: 42px;
                text-align: center;
                color: #0A070F;
            }
            p{
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 700;
                font-size: 10px;
                line-height: 5px;
                text-align: center;
                color: #0A070F;
                margin-top: -10px;
            }
            
        }
        .live-mode:hover {
            background: #0A070F;
           
            P{
                color: #FFF;
            }
            h3{
                color: #FFF;
            }
        }
        .party-mode {
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding: 10px;
            width: 220px;
            height: 160px;
            background: #19181B;
            border: 1px solid #D33E74;
            border-radius: 27px;
            cursor: pointer;
    
            h3{
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 700;
                font-size: 16px;
                line-height: 25px;
                text-align: center;
                color: #FFFFFF;
            }
            p{
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 700;
                font-size: 10px;
                line-height: 12px;
                text-align: center;
                color: #FFFFFF;
                margin-top: -10px;
            }
        }
        .player-name{
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 700;
            font-size: 18px;
            line-height: 31px;
            text-align: center;
            color: #FFFFFF;
    
        }
        .player-payinfo{
            display: flex;
            flex-direction: row;
            justify-content: center;
            //align-items: center;
            align-content: center;
            padding: 4px;
            width: 100%;
            height: 35px;
            background: rgba(211, 62, 116, 0.1);
            border-radius: 5px;
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 500;
            font-size: 10px;
            line-height: 14px;
            text-align: center;
            color: #D33E74;
            margin-top: 20px;
            display: block;
            margin-left: auto;
            margin-right: auto;
    
    
        }

        }
        .modal-close-mobile {
            color: #fff;
            line-height: 50px;
            font-size: 140%;
            position: absolute;
            right: 0;
            text-align: center;
            top: 2;
            width: 70px;
            text-decoration: none;
            &:hover {
              color: black;
            }
            display: block;
          }
        .tab {
            display: flex;
            flex-direction: row;
            text-align: center;
            width: 100%;
            padding: 1rem 0rem 0rem 6rem;
        
        
            .find-match {
            margin-top: -10px;
            width: 100%;
            height: 60px;
            background: #1E1D20;
            display: flex;
            flex-direction: columns;
            align-items: center;
            cursor: pointer;
        
            p {
                font-family: 'Raleway';
                font-style: normal;
                font-weight: 500;
                font-size: 14px;
                line-height: 28px;
                text-align: center;
                color: #D33E74;
            }
            }
            .your-matches {
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 28px;
            text-align: center;
            color: #767475;
            cursor: pointer;
            }
        
        }
        .navigation{
            padding: 1rem 2rem 3rem 4rem;
            margin-top: 30px;
            display: flex;
            flex-direction: row;
            
        // align-items: center;
            //justify-content: center;
        
            .elipse{
                float: right;
                margin-left: 90%;
            }
        }
        .photo-row{
           width: 100%;

           .margin {
             //margin: 0px;
           }

           .slider-indicator{
            position: absolute;
            top: 30px;
            left: 50px;
            width: 28px;
            height: 0px;
            border: 1px solid #D33E74;
            transform: rotate(180deg);
        }
        .slider-indicator2{
            position: absolute;
            top: 30px;
            left: 90px;
            width: 28px;
            height: 0px;
            border: 1px solid rgba(182, 182, 182, 0.43);
            transform: rotate(180deg);
        }
        .slider-indicator3{
            position: absolute;
            top: 30px;
            left: 140px;
            width: 28px;
            height: 0px;
            border: 1px solid rgba(182, 182, 182, 0.43);
            transform: rotate(180deg);
        }
        .slider-indicator4{
            position: absolute;
            top: 30px;
            left: 180px;
            width: 28px;
            height: 0px;
            border: 1px solid rgba(182, 182, 182, 0.43);
            transform: rotate(180deg);
        }
        .photo-footer{
            position: absolute;
            padding: 0rem 2rem;
            left: 0%;
            bottom: 0px;
            width: 100%;
            margin-left:0%;
            margin-right: 0%;

            h3{
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 500;
                font-size: 13px;
                line-height: 10px;
                text-align: left;
                color: #FFFFFF;
            }
            p{
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 400;
                font-size: 12px;
                line-height: 16px;
                text-align: left;
                color: #FFFFFF;
            }
        }
        }

        .photo {
            //position: absolute;
            width: 100%;
            height: 100%;
            background: linear-gradient(180deg, rgba(0, 0, 0, 0.25) 59.17%, rgba(0, 0, 0, 0.5) 80.14%), #2F2F2F;
            border-radius: 20px;
            //margin: 1px;
        }
        .profile-view{
            box-sizing: border-box;
            width: 100%;
            height: auto;
            background: #111112;
            margin-left: 75px;
        
            .profile-photo{
                width: 100%;
                height: 250px;
                background: linear-gradient(180deg, rgba(0, 0, 0, 0.25) 59.17%, rgba(0, 0, 0, 0.5) 80.14%), #2F2F2F;
            }
        }
        .profile-info {
            padding: 1rem 2rem 2rem 1rem;
            
            h3{
                font-family: 'Raleway';
                font-style: normal;
                font-weight: 800;
                font-size: 20px;
                line-height: 24px;
                text-align: left;
                color: #FFFFFF;
                margin-left: 20px;
            }
            p {
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 400;
                font-size: 13px;
                line-height: 10px;
                text-align: left;
                color: #767475;
                margin-left: 20px;
            }
        }
        .profile-bio{
            
            P {
                width: auto;
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 400;
                font-size: 12px;
                line-height: 154.2%;
                color: #767475;;
                text-align: left;
                margin:20px;
            }
        
        }
        .profile-interest{
        
            h3 {
                width: auto;
                height: 26px;
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 700;
                font-size: 20px;
                line-height: 26px;
                text-align: left;
                color: #FFFFFF;
                margin:20px;
            }
            .interests{
                box-sizing: border-box;
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                padding: 10px 40px;
                width: 83px;
                height: 29px;
                background: #111112;
                border: 1px solid #D33E74;
                border-radius: 50px;
                color: #767475;
                font-size: 12px;
                margin: 4px;
        
            }
            .interests-info {
                display: flex;
                flex-direction: row;
                margin: 20px;
            }
        
        }
        .profile-relationship-goal{
            h3 {
                width: auto;
                height: 26px;
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 700;
                font-size: 20px;
                line-height: 26px;
                text-align: left;
                color: #FFFFFF;
                margin:20px;
            }
            .relationship-goal {
                display: flex;
                flex-direction: row;
                padding: 10px;
                width: 70%;
                height: auto;
                background: rgba(255, 214, 0, 0.1);
                border-radius: 61px;
                color: #FFD600;
                font-size: 12px;
                margin: 20px;
                text-align: left;
            }
        
        }
        .btn-unmatch-report {
            display: flex;
            flex-direction: row;
            align-items: center;
        
        
            .btn-unmatch {
                box-sizing: border-box;
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                padding: 10px;
                width: 60%;
                height: 35px;
                background: #111112;
                border: 1px solid #D33E74;
                border-radius: 82px;
                font-family: 'Source Sans 3';
                font-style: normal;
                font-weight: 400;
                font-size: 16px;
                line-height: 28px;
                color: #D33E74;
                margin: 20px;
        
                
            }
            .btn-report {
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                padding: 10px;
                width: 60%;
                height: 35px;
                background: #2D2D2D;
                border-radius: 82px;
                font-family: 'Source Sans 3';
                font-style: normal;
                font-weight: 400;
                font-size: 16px;
                line-height: 28px;
                color: #767475;
                margin-right: 10px;
            }
        }

        .search-menu {
            display: flex;
            flex-direction: column;
            width: 100%;

            .location {
                margin: 4px;
                width: 100%;

                .input-location {
                    width: 100%;
                }
            }

            .location-range {
                width: 100%;
                
                .range {
                    padding: 0rem 0rem 0rem 0rem;

                    .men-women {
                        padding: 0rem 0rem 1rem 0rem;
                        p {
                            margin-left:20px;
                        }
                        .form-check-input{
                            background: #FFFFFF;
                            height: 20px;
                            width: 20px;
                            margin-top: 0px;
                        }
                        .form-check-input:checked{
                            background: #D33E74;
                            height: 22.5px;
                            width: 22.5px;
                        }
                        
                    }
                    .age-range {
                        width:100px;
                    p {
                        margin-left: 20px;
                    }
                    .slider-bg{
                        background: #252426;
                        border-radius: 22px;
                    }
                   }
                }
            }

            .btn-filter-cancel {
                display: flex;
                flex-direction: row;
                padding: 1rem 1rem 1rem 2rem;

                .btn-filter{
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                    padding: 10px;
                    width: 130px;
                    height: 35px;
                    background: #D33E74;
                    border-radius: 82px;
                    font-family: 'Source Sans 3';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 16px;
                    line-height: 23px;
                    color: #FFFFFF;
                }
                .btn-cancel{
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                    padding: 10px;
                    width: 130px;
                    height: 35px;
                    background: #2F2F2F;
                    border-radius: 82px;
                    border: 1px solid #D33E74;
                    font-family: 'Source Sans 3';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 16px;
                    line-height: 23px;
                    color: #D33E74;
                }
    
            }
        }
        .head-title {
            
            h2{
                font-family: 'Raleway';
                font-style: normal;
                font-weight: 900;
                font-size: 17px;
                line-height: 38px;
                text-align: left;
                color: #D33E74;
                margin-left: 0px;
                margin-top: 80px;
            }
            .models-search:hover{
                width: 150px;
            }
        }
    }
    .room-card{
        h5{
            color: #D33E74;
        }
        p{
            color: #CCC;
        }
    }
    .img-fluid{
        border-radius: 12px;
    }

.room-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 6px;
}
.img-fluid{
    transition: 0.3s ease;
}
.img-fluid:hover{
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  transform: translateY(-3px);
}

.room-card {
  background: #fff;
  border: 1px solid #ddd;
  padding: 10px;
  border-radius: 8px;
  transition: 0.3s ease;
  margin: 4px;
}
.room-card:hover {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  transform: translateY(-3px);
}

.escort-tour-card {
  background-color: transparent;
  border-radius: 10px;
  padding: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  margin: 5px;
  transition: 0.3s ease;
}

.escort-tour-card:hover {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  transform: translateY(-3px);
}
.fw-bold{
    color: #fff;
    small{
        color: #fff !important;
    }
}
.card-header{
    background-color: #fff;
    color: #D33E74;
}

button{
    text-decoration: none;
}
button:hover{
    text-decoration: none;
    color: #D33E74;
}

.escort-tour-img {
  width: 100%;
  height: 250px;
  object-fit: cover;
  border-radius: 8px;
}

.video-scroll-container {
  display: flex;
  overflow-x: auto;
  scroll-behavior: smooth;
  padding-bottom: 1rem;
  animation: scroll-left 30s linear infinite;
}

/* Optional: Hide scrollbar */
.video-scroll-container::-webkit-scrollbar {
  display: none;
}
.video-scroll-container {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

/* Auto scroll animation */
@keyframes scroll-left {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-50%);
  }
}

.auto-scroll-track {
  animation: scroll-left linear infinite;
  animation-duration: 10s;
}

@keyframes scroll-left {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-50%);
  }
}

.escort-video-card {
  min-width: 350px;
  max-width: 350px;
  flex-shrink: 0;
}

.escort-video-card video {
  height: 400px;
  width: 100%;
  object-fit: cover;
}


@media screen and (max-width: 700px) {
.margin-sub {
        margin-top: 10px;
    }
}


 
</style>